import React from "react";
import { useNavigate } from "react-router-dom";
import "./Packages.css";

const Packages = () => {
  const navigate = useNavigate();

  const handleNavigation = (category) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/tours/${category}`);
  };

  return (
    <section className="packages-section">
      <div className="packages-header">
        <h2>Discover Your Journey</h2>
        <p>Choose the perfect travel experience crafted just for you.</p>
      </div>

      <div className="packages-container">
        {/* Group Tours Card */}
        <div className="package-card" onClick={() => handleNavigation("group")}>
          <div className="image-wrapper">
            <img
              src="/img/customised-tours.jpg" // Replace with your group tour image
              alt="Group Tours"
              className="package-image"
            />
            <div className="overlay"></div>
          </div>
          <div className="package-content">
            <h3>Group Tours</h3>
            <p>
              Share the thrill of exploration with like-minded travelers. Enjoy
              expertly curated itineraries, dedicated guides, and unforgettable
              shared memories.
            </p>
            <button
              className="explore-btn"
              onClick={(e) => {
                e.stopPropagation(); // Prevents clicking button from triggering card click twice
                handleNavigation("group");
              }}
            >
              Explore Group Tours
            </button>
          </div>
        </div>

        {/* Customised Tours Card */}
        <div
          className="package-card"
          onClick={() => handleNavigation("customized")}
        >
          <div className="image-wrapper">
            <img
              src="/img/customised-tour.png" // Replace with your customized tour image
              alt="Customised Tours"
              className="package-image"
            />
            <div className="overlay"></div>
          </div>
          <div className="package-content">
            <h3>Customised Tours</h3>
            <p>
              Travel your exact way. Tailor every single detail of your vacation
              to your specific tastes, pace, and preferences for a truly unique
              adventure.
            </p>
            <button
              className="explore-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleNavigation("customized");
              }}
            >
              Design Your Tour
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Packages;
